import { useState, useEffect } from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Compass, Search } from 'lucide-react';
import WizardFlow from '@/components/wizard/WizardFlow';
import SymptomSearch from '@/components/wizard/SymptomSearch';

export default function FindIndicationPage() {
  const [tab, setTab] = useState('wizard');

  return (
    <div className="max-w-4xl" data-testid="find-indication-page">
      <div className="mb-6">
        <h1 className="font-heading text-2xl sm:text-3xl font-bold text-[#12100c]">
          Trova l'indicazione
        </h1>
        <p className="text-sm text-[#4a4238] mt-2 max-w-2xl leading-relaxed">
          Dove si colloca UMIFUL rispetto al caso che hai in mano: le aree coinvolte, cosa copre la letteratura e cosa si può dichiarare. Rispondi a quattro domande oppure cerca per sintomo.
        </p>
      </div>

      <Tabs value={tab} onValueChange={setTab} className="w-full">
        <TabsList className="w-full sm:w-auto grid grid-cols-2 sm:inline-grid sm:grid-cols-2 bg-[#12100c]/5 rounded-xl p-1 h-auto" data-testid="indication-tabs">
          <TabsTrigger
            value="wizard"
            className="rounded-lg data-[state=active]:bg-[#12100c] data-[state=active]:text-white data-[state=active]:shadow-sm px-4 py-2.5 text-sm font-medium transition-all"
            data-testid="tab-wizard"
          >
            <Compass className="w-4 h-4 mr-2" strokeWidth={1.5} />
            Parti dal caso
          </TabsTrigger>
          <TabsTrigger
            value="search"
            className="rounded-lg data-[state=active]:bg-[#12100c] data-[state=active]:text-white data-[state=active]:shadow-sm px-4 py-2.5 text-sm font-medium transition-all"
            data-testid="tab-search"
          >
            <Search className="w-4 h-4 mr-2" strokeWidth={1.5} />
            Ricerca per sintomo
          </TabsTrigger>
        </TabsList>

        <TabsContent value="wizard" className="mt-6">
          <WizardFlow />
        </TabsContent>

        <TabsContent value="search" className="mt-6">
          <SymptomSearch />
        </TabsContent>
      </Tabs>
    </div>
  );
}
